// extracted by mini-css-extract-plugin
export default {"screen":"MaintenanceScreen_screen__I9Q8H","contentText":"MaintenanceScreen_contentText__02YlF"};